import { useEffect } from 'react';
import { removeStaticHeroShell } from '../components/loading/AppBoot';

/** Drop the HTML static hero overlay after React hero has painted (keeps early LCP, avoids CLS). */
export function useRevealStaticHero() {
  useEffect(() => {
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        removeStaticHeroShell();
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, []);
}
